export class Step5 {
    constructor() {}

    public getspan12 = 'form.dive_at.getspan12';
    public getaddlot = 'form.dive_at.getaddlot';
    public getdeletelot = 'form.dive_at.getdeletelot';
    public getinfructueux = 'form.dive_at.getinfructueux';
    public getsanssuite = 'form.dive_at.getsanssuite';
    public getattribue = 'form.dive_at.getattribue';
    public getnumlot = 'form.dive_at.getnumlot';
    public getdescription = 'form.dive_at.getdescription';
    public getspan17 = 'form.dive_at.getspan17';
    public getspan19 = 'form.dive_at.getspan19';

    public getpersonnemorale = 'form.dive_at.getpersonnemorale';
    public getspan7 = 'form.dive_at.getspan7';
    public getcivilite = 'form.dive_at.getcivilite';
    public getnom = 'form.dive_at.getnom';
    public getpren = 'form.dive_at.getpren';
    public getfonc = 'form.dive_at.getfonc';
    public getspan8 = 'form.dive_at.getspan8';
    public getnum = 'form.dive_at.getnum';
    public gettypevoie = 'form.dive_at.gettypevoie';
    public getnomvoie = 'form.dive_at.getnomvoie';
    public getcp = 'form.dive_at.getcp';
    public getville = 'form.dive_at.getville';
    public getpays = 'form.dive_at.getpays';
    public gettel = 'form.dive_at.gettel';
    public getposte = 'form.dive_at.getposte';
    public getfax = 'form.dive_at.getfax';
    public getmel = 'form.dive_at.getmel';
    public getspan9 = 'form.dive_at.getspan9';
    public getmontantindefini = 'form.dive_at.getmontantindefini';
    public getvaleur = 'form.dive_at.getvaleur';
    public getmontantminiannuel = 'form.dive_at.getmontantminiannuel';
    public getmontantmaxiannuel = 'form.dive_at.getmontantmaxiannuel';
    public gettrancheconditionnelle = 'form.dive_at.gettrancheconditionnelle';
    public gettrancheferme = 'form.dive_at.gettrancheferme';
    public getoffrebasse = 'form.dive_at.getoffrebasse';
    public getoffreelevee = 'form.dive_at.getoffreelevee';
    public getspan10 = 'form.dive_at.getspan10';
    public getspan11 = 'form.dive_at.getspan11';
    public getsoustraitancenon = 'form.dive_at.getsoustraitancenon';
    public getvaleursoustraitance = 'form.dive_at.getvaleursoustraitance';
    public getpartpct = 'form.dive_at.getpartpct';
    public getpartinconnue = 'form.dive_at.getpartinconnue';
    public geturl = 'form.dive_at.geturl';
    public getspan13 = 'form.dive_at.getspan13';
    public getdevise = 'form.dive_at.getdevise';
    public getspan18 = 'form.dive_at.getspan18';
    public getintitule = "form.dive_at.getintitule";

}
